import { app_placeholder } from '../../../env.placeholders';
import { FilterApi } from '../../api';
import { HttpArcgis } from '../../http';
import { LocalStorage } from '../../localStorage';
import { prepareMultipleInseeCodesRequest } from '../map/defExpHelper';
import { getOptionsCommunes } from './filtersHelper';
import { createFormBodyHydroStats } from './hydroHelper';

export const definePayload = (pModule: string) => {
  let endPoint: string = '/HYDRO';
  switch (pModule) {
    case 'do':
      endPoint = '/DO';
      return endPoint;
    case 'pr':
      endPoint = '/PR';
      return endPoint;
    case 'ecp':
      endPoint = '/ECP';
      return endPoint;
    case 'h2s':
      endPoint = '/H2S';
      return endPoint;
    case 'indus':
      endPoint = '/INDUS';
      return endPoint;
    case 'milieu':
      endPoint = '/MILIEU';
      return endPoint;
    default:
      return endPoint;
  }
};

export const createFormBodyBc = (pContractCode: string) => {
  let queryBC: string = "ContractCode in ('" + pContractCode + "')";
  const formBodyBC: string[] = [];
  formBodyBC.push('where=' + queryBC);
  formBodyBC.push('outFields=CollectionPoolCode,Length');
  formBodyBC.push('returnGeometry=true');
  formBodyBC.push('orderByFields=CollectionPoolCode');
  formBodyBC.push('f=json');
  formBodyBC.push('user=' + LocalStorage.userMail.get());
  const formBodyToSend = formBodyBC.join('&');
  return formBodyToSend;
};

export const getPointsForCollectionPoolsEcp = async (pContractCode: string) => {
  let result: any[] = [];
  try {
    // get all aval/amont points for each bc
    const responseAvalPoints = await FilterApi.getBassin('', pContractCode);
    responseAvalPoints.data.forEach((bc: any) => {
      result.push({
        id: bc.id,
        name: bc.label,
        avalPoint: bc.avalPoint,
        commune: bc.commune,
      });
    });
    if (result.length === 0) {
      console.log("Aucun bassin de collecte remonté par l'api data !");
    }
    return result;
  } catch (error) {
    console.log('Failed to get data for table (getBassin) !', error);
    return result;
  }
};

export const getRenderProps = async () => {
  let datas: any;
  // get renderer of layer 3 (collection pool id 3)
  const formBodyBC: string[] = [];
  formBodyBC.push('f=json');
  formBodyBC.push('user=' + LocalStorage.userMail.get());
  const formBodyToSend = formBodyBC.join('&');

  try {
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/3',
      JSON.stringify(formBodyToSend)
    );
    if (
      responseSections.status === 200 &&
      responseSections.data.id !== undefined
    ) {
      datas = responseSections.data;
    } else {
      console.log('Aucune données !');
      datas = [];
    }
    return datas;
  } catch (error) {
    console.log('Failed to get legend !', error);
    return [];
  }
}

export const getCommunesForEcp = async (pContractCode: string) => {
  let newCommunesData: any[] = [];
  // changer la source de l'api => service carto à prendre en compte
  try {
    const optionsCommune = await FilterApi.getCommunesECP(pContractCode);
    optionsCommune.data.forEach((c: any) => {
      newCommunesData.push({
        name: c.name,
        code: c.inseeCode,
        outField: 'InseeCode',
      });
    });
    return newCommunesData;
  } catch (error) {
    console.log('Failed to get communes for ECP !', error);
    return newCommunesData;
  }
};

export const getCommunesForIndus = async (pContractCode: string) => {
  // get communes
  let data: any[] = [];
  try {
    const responseCommunes = await getOptionsCommunes(
      pContractCode,
      '7',
      'indus'
    );
    if (responseCommunes.length === 0) {
      console.log('Aucune communes remontées !');
    }
    data = responseCommunes;
    return data;
  } catch (error) {
    console.log('Failed to get data for table !', error);
    return data;
  }
}

export const getCollectionPoolsList = async (pContractCode: string, pModule: string) => {
  // get geom of BC
  let dataBC: any[] = [];
  const formBodyToSend = createFormBodyBc(pContractCode);

  try {
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/3/query',
      JSON.stringify(formBodyToSend)
    );
    let datasBC;
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datasBC = responseSections.data.features;
      if (datasBC.length === 0) {
        console.log('Aucune BC remontés !');
      }
    } else {
      console.log('Aucune données !');
      datasBC = [];
    }
    // get attibutes
    datasBC.forEach((feat) => {
      if(pModule === 'indus'){
        dataBC.push({
          name: feat['attributes'].CollectionPoolCode,
          code: feat['attributes'].CollectionPoolCode,
          paths: feat['geometry'].paths,
        });
      } else {
        // hydro
        dataBC.push({
          name: feat['attributes'].CollectionPoolCode,
          paths: feat['geometry'].paths,
          length: feat['attributes'].Length,
        });
      }
    });
    return dataBC;
  } catch (error) {
    console.log('Failed to get data for table !', error);
    return dataBC;
  }
};

export const getCommunesForHydro = async (pContractCode: string) => {
  let dataCommunes: any[] = [];
  try {
    const optionsCommune = await getOptionsCommunes(
      pContractCode,
      '51',
      'hydro'
    );
    if (optionsCommune.length === 0) {
      console.log('Aucune communes remontées !');
    }
    dataCommunes = optionsCommune;
    return dataCommunes;
  } catch (error) {
    console.log('Failed to get data for table !', error);
    return dataCommunes;
  }
};

export const getLinearsForHydro = async (paramsAllInseeCodesContract: any) => {
  // get linears for communes and bc
  let query: string =
    "ContractCode in ('" +
    window.sessionStorage.getItem('contractCode') +
    "') AND InseeCode in (" +
    prepareMultipleInseeCodesRequest(paramsAllInseeCodesContract) +
    ") AND PipeNature in ('TRC')";
  let datas: any[] = [];
  let data: any[] = [];
  const formBodyToSend = createFormBodyHydroStats(query, 'bc');
  try {
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/4/query',
      JSON.stringify(formBodyToSend)
    );
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
      // get attibutes
      datas.forEach((feat) => {
        data.push({
          type: 'commune',
          inseeCode: feat['attributes'].InseeCode,
          linear: Math.round(feat['attributes'].Length),
        });
      });
      if (datas.length === 0) {
        console.log('Aucune longueurs de réseau par commune remontées !');
        return data;
      }
      return data;
    } else {
      console.log('Aucune données !');
      return data;
    }
  } catch (error) {
    console.log('Failed to get linears for number of debouchage !', error);
    return data;
  }
};

// Change H2S indicators colors function
export const changeColors = (prevState, indicator) => {
  const clicked = '#63d1b5';
  const unclicked = 'rgb(237, 242, 250)';
  const newState = {};

  Object.keys(prevState).forEach((key) => {
    newState[key] = key === indicator ? clicked : unclicked;
  });

  return newState;
};